'use client';
// Ads landing capture (15/10/26): a category page reached with ?tt=<topic-slug> / ?tq=<text> remembers the intent in the
// ex_tq cookie (via readTagQuery), so the pro page the visitor opens next shows the matching photos/reviews first.
// Renders nothing; without the param it reads the cookie and changes nothing.
import { useEffect } from 'react';
import { readTagQuery } from '@/components/tagContext';

export default function TagQueryCapture() {
  useEffect(() => { readTagQuery(); }, []);
  return null;
}
